import React from 'react';
import styles from './FilePreviewCard.module.css';

const FilePreviewCard = ({ file, onDownload, onOpen }) => {
  // Determine file icon based on file type
  const getFileIcon = (fileType, fileName) => {
    if (fileType === 'application/pdf') {
      return '📄';
    } else if (fileType === 'text/plain') {
      return '📝';
    } else if (fileName.toLowerCase().endsWith('.docx') || fileName.toLowerCase().endsWith('.doc')) {
      return '📘';
    } else if (fileType.startsWith('image/')) {
      return '🖼️';
    } else {
      return '📎';
    }
  };

  // Format file size
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  // Get file type display name
  const getFileTypeDisplay = (fileType, fileName) => {
    if (fileType === 'application/pdf') {
      return 'PDF';
    } else if (fileType === 'text/plain') {
      return 'TXT';
    } else if (fileName.toLowerCase().endsWith('.docx')) {
      return 'DOCX';
    } else if (fileName.toLowerCase().endsWith('.doc')) {
      return 'DOC';
    } else if (fileType.startsWith('image/')) {
      return 'Image';
    } else {
      return 'File';
    }
  };

  const handleDownload = () => {
    if (onDownload) {
      onDownload(file);
    } else if (onOpen) {
      onOpen(file);
    }
  };

  return (
    <div className={styles.filePreviewCard}>
      <div className={styles.fileIcon}>
        {getFileIcon(file.type, file.name)}
      </div>
      <div className={styles.fileInfo}>
        <div className={styles.fileName}>{file.name}</div>
        <div className={styles.fileDetails}>
          <span className={styles.fileType}>{getFileTypeDisplay(file.type, file.name)}</span>
          {file.size && (
            <>
              <span className={styles.separator}>•</span>
              <span className={styles.fileSize}>{formatFileSize(file.size)}</span>
            </>
          )}
        </div>
      </div>
      <button 
        className={styles.actionButton}
        onClick={handleDownload}
        title="Open file"
      >
        Open
      </button>
    </div>
  );
};

export default FilePreviewCard; 